import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox';
import { useHistory } from 'react-router';
import { Checkbox } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobal } from 'store/global/reducer';
import styled from 'styled-components/macro';
import TextHeader from 'components/CustomText/TextHeader';
import useDialog from 'components/ConfirmDialog/useDialog';
import CustomRadio from "components/CustomRadio";

const SLayout = styled.div``;

const SInputColumn = styled.div`
    width: 100%;
    margin-top: 20px;
`;
const SDisplayLayout = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 5px;
    flex-shrink: 0;
`;

const CloneToDraftModal = ({ open }) => {
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const rowId = useSelector((state) => state.global.rowId);
    const callback = useSelector((state) => state.global.callback);
    const [withSites, setWithSites] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (open) {
            setWithSites(false);
        }
    }, [open]);

    const onClose = () => {
        dispatch(
            setGlobal({
                isCloneToDraftOpen: false,
                appId: null,
                callback: () => {},
            }),
        );
    };

    const onSubmit = () => { 
        callback?.();
        console.log('alan333', rowId, withSites);
        
        history.push(`/applications/clone?cloneId=${rowId}&cloneSite=${withSites}`);
        onClose();
    }

    return (
        <SLayout>
            <Dialog PaperProps={{ style: { padding: '16px 0 0 24px' } }} fullWidth={true} maxWidth={'sm'} open={open} onClose={onClose}>
                <DialogTitle style={{ padding: 0 }}>
                    <TextHeader>
                        Do you want to clone the submission?
                    </TextHeader>
                </DialogTitle>

                <DialogContent style={{ display: 'flex' }}>
                    {/* <Checkbox
                        checked={withSites}
                        onChange={e => setWithSites(e.target.checked)}
                        style={{ padding: 0 }}
                        color={'primary'}
                        size="small"
                    />
                    <SDisplayLayout>with site(s)</SDisplayLayout> */}
                    <CustomRadio
                        value={withSites}
                        onChange={(e) => setWithSites(e.target.value === 'true')}
                        flexDirection="column"
                        isRequired
                        operators={[
                            { 
                                key: false, 
                                label: 'Study Info Only', 
                            },
                            { 
                                key: true, 
                                label: 'Study Info & Existing Site Info tab(s)', 
                            },
                        ]}
                    />
                </DialogContent>
                <DialogActions>
                    <CustomButton type={'cancel'} onClick={onClose} color="primary">
                        Cancel
                    </CustomButton>
                    <CustomButton onClick={onSubmit} autoFocus>
                        Confirm
                    </CustomButton>
                </DialogActions>
            </Dialog>
        </SLayout>
    );
};

export default CloneToDraftModal;
